import { RouteRecordRaw } from 'vue-router'

const degreeApplicationRoutes: RouteRecordRaw = {
  path: '/degree-application',
  name: 'DegreeApplication',
  component: () => import('@/views/DegreeApplication/index.vue'),
  meta: {
    title: '学位申请',
    icon: 'graduation-cap',
    requiresAuth: true
  },
  children: [
    {
      path: '',
      name: 'DegreeApplicationOverview',
      component: () => import('@/views/DegreeApplication/Overview.vue'),
      meta: {
        title: '总览',
        keepAlive: true,
        requiresAuth: true
      }
    },
    {
      path: 'advisor',
      name: 'AdvisorSelection',
      component: () => import('@/views/DegreeApplication/AdvisorSelection.vue'),
      meta: {
        title: '导师选择',
        keepAlive: true,
        requiresAuth: true
      }
    },
    {
      path: 'proposal',
      name: 'ProposalReport',
      component: () => import('@/views/DegreeApplication/ProposalReport.vue'),
      meta: {
        title: '开题报告',
        keepAlive: true,
        requiresAuth: true
      }
    },
    {
      path: 'thesis',
      name: 'ThesisSubmission',
      component: () => import('@/views/DegreeApplication/ThesisSubmission.vue'),
      meta: {
        title: '论文提交',
        keepAlive: true,
        requiresAuth: true
      }
    },
    {
      path: 'plagiarism',
      name: 'PlagiarismManagement',
      component: () => import('@/views/DegreeApplication/PlagiarismManagement.vue'),
      meta: {
        title: '查重管理',
        keepAlive: true,
        requiresAuth: true
      }
    },
    {
      path: 'defense',
      name: 'DefenseManagement',
      component: () => import('@/views/DegreeApplication/DefenseManagement.vue'),
      meta: {
        title: '答辩管理',
        keepAlive: true,
        requiresAuth: true
      }
    },
    {
      path: 'degree',
      name: 'DegreeApplicationForm',
      component: () => import('@/views/DegreeApplication/DegreeApplication.vue'),
      meta: {
        title: '学位申请',
        keepAlive: true,
        requiresAuth: true
      }
    },

  ]
}

export default degreeApplicationRoutes 